import { InjectionKey } from 'vue'

export interface StrapiConfig {
  apiUrl: string
  apiKey: string
}

export const STRAPI_CONFIG_KEY: InjectionKey<StrapiConfig> =
  Symbol('strapiConfig')
